import React, { useState } from "react";
import danteF from "../../assets/danteF.png";
import "./features.css";

const Features = () => {
  // Özellik verileri
  const features = [
    {
      id: 1,
      number: "1.",
      heading: "Real-Time Access to Distributed GPU Resources",
      description:
        "AI agents can instantly discover available GPU \n resources through a blockchain-powered \n marketplace and scale their workloads efficiently.",
    },
    {
      id: 2,
      number: "2.",
      heading: "Autonomous GPU Selection & Optimization",
      description:
        "AI agents can select GPUs based on VRAM, \n processing power, and bandwidth requirements \n while optimizing usage based on cost and performance.",
    },
    {
      id: 3,
      number: "3.",
      heading: "Flexible Usage Model & Lower Costs",
      description:
        "Unlike traditional services, DanteGPU offers a \n pay-as-you-go model with no subscription \n commitments.",
    },
    {
      id: 4,
      number: "4.",
      heading: "Accelerated Model Training",
      description:
        "Distributed processing speeds up AI model \n training by parallelizing workloads across multiple \n GPUs.",
    },
    {
      id: 5,
      number: "5.",
      heading: "Secure & Transparent Transactions",
      description:
        "Solana blockchain integration ensures transparent \n and immutable records of transactions between \n GPU providers and AI agents.",
    },
  ];

  // Aktif özellik durumu
  const [activeIndex, setActiveIndex] = useState(0);

  // Önceki özelliğe geçiş
  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? features.length - 1 : prevIndex - 1
    );
  };

  // Sonraki özelliğe geçiş
  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === features.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Aktif özellik
  const activeFeature = features[activeIndex];

  // Metni belirli kelime sayısına göre satırlara ayırma
  const formatWithLineBreaks = (text, wordsPerLine) => {
    const words = text.split(" ");
    let lines = [];

    for (let i = 0; i < words.length; i += wordsPerLine) {
      lines.push(
        words.slice(i, Math.min(i + wordsPerLine, words.length)).join(" ")
      );
    }

    return lines;
  };

  // Başlık ve açıklamayı satırlara bölme
  const headingLines = formatWithLineBreaks(activeFeature.heading, 3);
  const descriptionLines = formatWithLineBreaks(activeFeature.description, 7);

  return (
    <section className="features">
      <div className="features-container">
        <div className="features-left">
          <img className="danteF" src={danteF} alt="danteF" />
        </div>

        <div className="features-right">
          <div className="aligned-content">
            <h2 className="features-title">Features</h2>
            <div className="feature-item">
              <div className="feature-number">{activeFeature.number}</div>
              <div className="feature-content">
                <h3 className="feature-heading">
                  {headingLines.map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < headingLines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </h3>
                <p className="feature-description">
                  {descriptionLines.map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < descriptionLines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            </div>

            <div className="feature-navigation">
              <button className="nav-button prev" onClick={handlePrev}>
                ←
              </button>
              <button className="nav-button next" onClick={handleNext}>
                →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
